import { useEffect } from 'react';

import {
  PageValues,
  usePageContext,
} from '@providers/PageMetaProvider/model/PageContext.ts';
import usePageTitle from '@hooks/usePageTitle/usePageTitle.ts';
import DocumentPromptPreviewTable from '@features/admin-document-prompt-preview/containers/DocumentPromptPreviewTable';

const pageValues: PageValues = {
  title: 'Document Types',
};

function DocumentPromptPreviewPage() {
  usePageTitle('ZlaytAI - Document Types');
  const { setValues } = usePageContext();

  useEffect(() => {
    if (setValues) {
      setValues((prev) => ({
        ...prev,
        ...pageValues,
      }));
    }
  }, []);

  return <DocumentPromptPreviewTable />;
}

export default DocumentPromptPreviewPage;
